import { cardVisitConstants } from "../constants";

const initialState = {
    visits: []
};

export function card_visit(state = initialState, action) {
    switch (action.type) {
        case cardVisitConstants.GET_CARD_VISITS:
            const visits = action.payload;

            return { 
                        ...state,
                        visits
                    };
        case cardVisitConstants.CREATE_CARD_VISITS:
            const updatedVisits = [...state.visits.filter(v => v.id !== action.payload.id), action.payload];


            return {
                        ...state,
                        visits: updatedVisits
                    };
        default:
            return state;
    }
}